import React from 'react';
import { FaPhoneAlt, FaCalendarCheck, FaTools, FaShieldAlt } from 'react-icons/fa';
import './ProcessSteps.css';

const steps = [
  {
    icon: <FaPhoneAlt />,
    title: 'Bizi Arayın',
    desc: '7/24 telefon veya WhatsApp hattımızdan ulaşın, arızanızı anlatın.',
  },
  {
    icon: <FaCalendarCheck />,
    title: 'Randevu Alın',
    desc: 'Size uygun gün ve saate randevu oluşturalım, ekibimiz yola çıksın.',
  },
  {
    icon: <FaTools />,
    title: 'Yerinde Servis',
    desc: 'Uzman teknisyenimiz adresinize gelir, arızayı yerinde çözer.',
  },
  {
    icon: <FaShieldAlt />,
    title: 'Garanti',
    desc: 'İşçilik garantisi ile teslim; sorun yaşarsanız tekrar yanınızdayız.',
  },
];

const ProcessSteps = () => {
  return (
    <section className="process-steps section" aria-labelledby="process-heading">
      <div className="section-inner">
        <div className="section-header">
          <h2 id="process-heading" className="section-title">Servis Sürecimiz</h2>
          <p className="section-subtitle">
            Dört basit adımda hızlı ve güvenilir teknik servis deneyimi.
          </p>
        </div>

        <ol className="ps-grid">
          {steps.map((step, i) => (
            <li className="ps-item" key={i}>
              <div className="ps-icon">{step.icon}</div>
              <span className="ps-number">{i + 1}</span>
              <h3 className="ps-title">{step.title}</h3>
              <p className="ps-desc">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ProcessSteps;
